export default "__VITE_ASSET__f411f03b__"